import type { FC } from "react"

import StyledChip from "@/components/common/Chip/Chip"
import { type Invoice, InvoiceStatus } from "@/graphql/codegen/graphql"
import { formatDate } from "@/utils/date"

interface InvoicesDatePaidCellProps {
  invoice: Pick<Invoice, "status" | "paidDate" | "dueDate">
}

export const InvoicesDatePaidCell: FC<InvoicesDatePaidCellProps> = ({ invoice }) => {
  // Branch 1: Paid status — show the date the pay file containing this
  // invoice was sent (AK-6401 exposes this on the schema as `paidDate`).
  if (invoice.status === InvoiceStatus.Paid) {
    return invoice.paidDate ? formatDate(invoice.paidDate) : null
  }

  // Branch 2: Due Date is in the past and status is not Paid / Cancelled → "Overdue" chip.
  // Compare ISO-date strings (YYYY-MM-DD) rather than Date objects: `new Date("2026-06-15")`
  // parses as UTC midnight while `new Date()` is the current local instant, so an Object
  // comparison flags the same calendar day as overdue once the user passes midnight UTC. ISO
  // date strings sort lexicographically and avoid the timezone-mixing footgun.
  const todayIsoDate = new Date().toISOString().slice(0, 10)
  const isOverdue = invoice.status !== InvoiceStatus.Cancelled && invoice.dueDate < todayIsoDate

  if (isOverdue) {
    return <StyledChip label='Overdue' className='bg-secondary-200 text-gray-900' size='small' />
  }

  // Branch 3: blank
  return null
}
